<template>
  <div v-show="listType === 'grid' || listType === 'map'"
       :class="['grid-tour-result-list', {'map-mode': listType === 'map'}, {'hidden': hiddenResult}]">

    <country-info v-show="listType === 'grid' && tourResultList.length" />

    <div v-for="(item, key) in tourResultList"
         :key="key"
         :class="['card-wrap', { collapse }]">
      <div class="layer layer-1"></div>
      <div class="layer layer-2"></div>

      <div class="card relative">
        <div ref="resultHeadlineGrid" class="card-header justify-between">
          <a ref="resultHeadlineTextGrid"
             v-if="item.TourUrl"
             :href="item.TourUrl"
             target="_blank"
             class="program-name ellipsis link"
             :title="cardTitle(item, key)"
             v-text="cardTitle(item, key)">
          </a>
          <p ref="resultHeadlineTextGrid"
             v-else
             class="program-name ellipsis"
             :title="cardTitle(item, key)"
             v-text="cardTitle(item, key)">
          </p>

          <p v-if="collapse"
             class="more-hotels"
             @click="selectHotel(item)">
            {{localizeList.moreОptions}}
          </p>
          <icon v-else-if="item.BookingConditions || hasTourImages(sliderDefaultImage[key])"
                @click.native="rightModalBooking(item.BookingConditions, item, key)"
                name="info" width="20px" height="20px" fill="var(--lighten-5-color)" class="ml-4 pointer" />
        </div>
        <div class="card-body">

          <!--Слидер картинок отеля-->
          <div v-show="listType === 'grid'" class="slider">
            <result-slider-new
              @click.self="rightModalHotelOrTourInfo(item, key, $event)"
              :defaultimage="smallImgToMedium(sliderDefaultImage[key])"
              :default-image-count="sliderDefaultImageCount[key]"
              :tour-images="imgFilterByTourKey(tourAllImages, item)"
              :item="item"/>
          </div>

          <div class="rows-container">
            <div v-for="(item2, hotelIndex) in item.hotels" :key="hotelIndex">
              <div v-show="getHotelName(item)" class="hotel-name">
                <template v-if="isActiveHotelName(item, hotelIndex)">
                  <a v-if="item2.Hotel.Http || item2.Http"
                     @click.prevent="rightModalHotelInfo(item, key, hotelIndex)"
                     :href="item2.Hotel.Http || item2.Http || ''"
                     :title="item2.Hotel.Value"
                     class="pointer ellipsis">
                    {{ item2.Hotel.Value }} {{ typeof getSubHotelStars(item2.Stars.Value) === "string" ? getSubHotelStars(item2.Stars.Value) : "" }}
                  </a>
                  <span v-else 
                        @click.prevent="rightModalHotelInfo(item, key, hotelIndex)"
                        :title="item2.Hotel.Value"
                        class="pointer mr-4 ellipsis">
                    {{ item2.Hotel.Value }} {{ typeof getSubHotelStars(item2.Stars.Value) === "string" ? getSubHotelStars(item2.Stars.Value) : "" }}
                  </span>
                </template>
                <span v-else :title="getHotelName(item)"
                   class="ellipsis">
                  {{ item2.Hotel.Value }} {{ typeof getSubHotelStars(item2.Stars.Value) === "string" ? getSubHotelStars(item2.Stars.Value) : "" }}
                </span>
                <div v-if="typeof getSubHotelStars(item2.Stars.Value) === 'number'" class="hotel-stars">
                  <div v-for="(_, key3) in getSubHotelStars(item2.Stars.Value)" :key="key3">
                    <icon name="star" width="14px" height="14px" fill="var(--yellow-color)"/>
                  </div>
                </div>
              </div>

              <div class="city-resort-info-wrap">
                <p class="city-resort-info-text ellipsis">{{ getHotelCityAndResort(item, hotelIndex) }}</p>
              </div>

              <p v-show="!getHotelName(item)"
                 class="no-hotel-text">
                {{ getNoHotelText(item) }}
              </p>
              <div v-show="listType === 'map'">
                <p v-if="!collapse" class="date-info ml-5 mr-5"
                   @mouseleave="hidePopover()"
                   @mouseenter="showPopover(getAdditionalDataTitle(item), $event, false)">
                  {{getTourDate(item) + ", " + getTourDuration(item)}}<i>{{getTravelDuration(item)}}</i>)
                </p>
                <p v-else @click="selectHotel(item)" class="more-hotels ml-5 mr-5">
                  {{getTourDate(item)}}
                </p>
                <p class="date-info ml-5 mr-5">
                  {{getTourTourist()}}
                </p>
              </div>
              <div v-show="listType === 'grid' || listType === 'map'" class="features" :style="{height: maxFeaturesHeight}">
                <div class="popover-link"
                     v-for="(item3, key3) in getHotelType(item, hotelIndex)"
                     :key="key3"
                     @mouseleave="hidePopover()"
                     @mouseenter="showPopover(item3.Value, $event)">
                  <img width="18px" height="18px" :src="getHotelTypeIcon(item3.Key)"
                       class="hotel-type-icon"/>
                </div>
                
                <div class="CO-specials align-center">
                  <div class="popover-link"
                      v-for="(item3, key3) in getHotelCOAndSpecialInfo(item, hotelIndex)" :key="`${key3}_2`">
                        <div v-if="hasCoImage(item3.id)" 
                             v-show="item3.title"
                             @mouseleave="hidePopover()"
                             @mouseenter="showPopover(item3.title, $event, true)"> 
                          <img v-if="item3.type === 1"
                               width="20px" height="20px"
                               :src="item3.src"
                               class="hotel-type-icon"/>
                          <img v-else
                               width="26px" height="26px"
                               style="margin-top: -4px"
                               :src="item3.src"
                               class="hotel-type-icon"/>
                        </div>
                        <div v-else-if="item3.title.length > 1"
                             v-show="item3.title"
                             @mouseleave="hidePopover()"
                             @mouseenter="showPopover(item3.title, $event, true)">
                          <img v-if="item3.type === 1"
                               width="20px" height="20px"
                               :src="item3.src"
                               class="hotel-type-icon"/>
                          <img v-else
                               width="26px" height="26px"
                               style="margin-top: -4px"
                               :src="item3.src"
                               class="hotel-type-icon"/>
                        </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div v-show="listType === 'grid'" class="services">
            <div v-if="hasFlight(item)"
                 class="popover-link service"
                 @mouseleave="hidePopover()"
                 @mouseenter="showPopover(getFlightOrHotelQuotaText(item, 1), $event)">
              <base-button @click.native="rightModalAviaFlight(item)"
                           background="transparent"
                           class="relative"
                           padding="5px">
                <icon name="flight" width="20px" height="20px" fill="var(--lighten-5-color)"/>
                <div class="quota-line" :style="{backgroundColor: getServiceQuotaStatus(item, 1) }"></div>
              </base-button>
            </div>

            <div @mouseover="item.hoverHotelsList = true"
                 @mouseleave="item.hoverHotelsList = false"
                 v-if="getHotelName(item)"
                 :class="['hotel-btn-wrap', {'no-flight': !hasFlight(item)}]">
              <div class="popover-link service"
                   @mouseleave="hidePopover()"
                   @mouseenter="showPopover(getFlightOrHotelQuotaText(item, 3), $event)">
                <base-button @click="showHotelList(item, key)"
                             background="transparent"
                             class="relative"
                             padding="5px">
                  <div class="relative" style="height: 20px">
                    <p v-if="item.hotels.length > 1"
                       @mouseenter="stop"
                       class="count">+{{item.hotels.length-1}}</p>

                    <icon name="hotel" width="20px" height="20px" fill="var(--lighten-5-color)"/>
                  </div>
                  <div class="quota-line" :style="{backgroundColor: getServiceQuotaStatus(item, 3) }"></div>
                </base-button>
              </div>
              <div v-if="item.showHotelsList"
                   @mouseover="item.hoverHotelsList = true"
                   @mouseleave="item.hoverHotelsList = false"
                   :class="['hotel-list', {'no-flight': !hasFlight(item)}]">
                <div v-for="(item2, key2) in item.hotels"
                     :key="key2"
                     @click="rightModalHotelInfo(item, key, key2)"
                     class="hotel-item">
                  <p class="nowrap yellow-text-small mr-2">{{shortDate(item2.BeginDateTime)}} /</p>
                  <p class="nowrap yellow-text-small mr-2">{{correctDurationNight(item2.DurationInNight)}} /</p>
                  <p class="nowrap mr-2">{{item2.City.Value}} /</p>
                  <div class="align-center">
                    <p class="nowrap mr-2">{{item2.Hotel.Value}}</p>

                    <div v-if="typeof getStars(item2.Stars.Value) === 'number'"
                         class="hotel-stars flex">
                      <div v-for="(item3, key3) in getStars(item2.Stars.Value)"
                           :key="key3">
                        <icon name="star" width="14px" height="14px" fill="var(--yellow-color)"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="services-list">
              <div v-for="(item2, key2) in getServices(item)"
                   :key="key2"
                   :style="{'order': item2[0].order}"
                   :class="['popover-link service', {'none-left': !hasFlight(item) && !getHotelName(item)}]"
                   @mouseleave="hidePopover()"
                   @mouseenter="showPopover(getServiceName(item2), $event)">
                <base-button background="transparent"
                             :class="{'pointer relative': item2[0].SvKey === 14 || item2[0].SvKey === 2}"
                             @click="serviceClick(item2)"
                             padding="5px">
                  <div class="relative" style="height: 20px">
                    <p v-show="showServiceCount(item2)" class="count">+{{item2.length-1}}</p>

                    <icon v-if="item2[0].typeIcon === 'taxi'"
                          name="taxi" width="20px" height="20px" fill="var(--lighten-5-color)"/>
                    <icon v-else-if="item2[0].typeIcon === 'excursion'"
                          name="excursion" width="20px" height="20px" fill="var(--lighten-5-color)"/>
                    <icon v-else-if="item2[0].typeIcon === 'bus'"
                          name="bus" width="20px" height="20px" fill="var(--lighten-5-color)"/>
                    <icon v-else-if="item2[0].typeIcon === 'train'"
                          name="train" width="20px" height="20px" fill="var(--lighten-5-color)"/>
                    <icon v-else-if="item2[0].typeIcon === 'network'"
                          name="network" width="20px" height="20px" fill="var(--lighten-5-color)"/>

                  </div>
                  <div class="quota-line" :style="{backgroundColor: getServiceQuotaStatus(item2) }"></div>
                </base-button>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div v-show="listType === 'grid'" class="additional-info">
            <p v-if="collapse"
               @click="selectHotel(item)"
               class="more-hotels">{{getTourDate(item)}}</p>
            <p v-else class="ligth-grey-text-small text-500">{{getTourDate(item)}}</p>
            <p
                class="ligth-grey-text-small text-500"
                @mouseleave="hidePopover()"
                @mouseenter="showPopover(getAdditionalDataTitle(item), $event, false)">{{getTourDuration(item)}}<i>{{getTravelDuration(item)}}</i>)</p>
            <p class="ligth-grey-text-small text-500">{{getTourTourist()}}</p>
          </div>

          <div v-show="listType === 'map'" class="additional-info">
            <div class="img mr-8"
                 @click.self="rightModalHotelOrTourInfo(item, key, $event)"
                 :style="{backgroundImage: getMainImage(key)}"></div>

            <div v-if="hasFlight(item)"
                 class="popover-link service mr-8"
                 @mouseleave="hidePopover()"
                 @mouseenter="showPopover(getFlightOrHotelQuotaText(item, 1), $event)">
              <base-button @click.native="rightModalAviaFlight(item)"
                           background="transparent"
                           class="relative"
                           padding="5px">
                <icon name="flight" width="20px" height="20px" fill="var(--lighten-5-color)"/>
                <div class="quota-line" :style="{backgroundColor: getServiceQuotaStatus(item, 1) }"></div>
              </base-button>
            </div>

            <div @mouseover="item.hoverHotelsList = true"
                 @mouseleave="item.hoverHotelsList = false"
                 v-if="getHotelName(item)"
                 :class="['hotel-btn-wrap mr-8', {'no-flight': !hasFlight(item)}]">
              <div class="popover-link service"
                   @mouseleave="hidePopover()"
                   @mouseenter="showPopover(getFlightOrHotelQuotaText(item, 3), $event)">
                <base-button @click="showHotelList(item, key)"
                             background="transparent"
                             class="relative"
                             padding="5px">
                  <div class="relative" style="height: 20px">
                    <p v-if="item.hotels.length > 1"
                       @mouseenter="stop"
                       class="count">+{{item.hotels.length-1}}</p>

                    <icon name="hotel" width="20px" height="20px" fill="var(--lighten-5-color)"/>
                  </div>
                  <div class="quota-line" :style="{backgroundColor: getServiceQuotaStatus(item, 3) }"></div>
                </base-button>
              </div>
              <div v-if="item.showHotelsList"
                   @mouseover="item.hoverHotelsList = true"
                   @mouseleave="item.hoverHotelsList = false"
                   :class="['hotel-list', {'no-flight': !hasFlight(item)}]">
                <div v-for="(item2, key2) in item.hotels"
                     :key="key2"
                     @click="rightModalHotelInfo(item, key, key2)"
                     class="hotel-item">
                  <p class="nowrap yellow-text-small mr-2">{{shortDate(item2.BeginDateTime)}} /</p>
                  <p class="nowrap yellow-text-small mr-2">{{correctDurationNight(item2.DurationInNight)}} /</p>
                  <p class="nowrap mr-2">{{item2.City.Value}} /</p>
                  <div class="align-center">
                    <p class="nowrap mr-2">{{item2.Hotel.Value}}</p>

                    <div v-if="typeof getStars(item2.Stars.Value) === 'number'"
                         class="hotel-stars flex">
                      <div v-for="(item3, key3) in getStars(item2.Stars.Value)"
                           :key="key3">
                        <icon name="star" width="14px" height="14px" fill="var(--yellow-color)"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div @click="toggleBuyList(key, item)"
               @mouseleave="leaveList(key)"
               @mouseenter="hoverList(key)"
               class="buy-btn-wrap">

            <div v-if="buyListShow[key]"
                 class="buy-list">
              <div class="buy-item-wrap"
              :class="{ 'buy-item-wrap-first': key === 0 && listType === 'map' }">
                <div v-for="(item2, key2) in buyList[key]"
                     :key="key2"
                     @click="buyTour(item2, key2)"
                     class="buy-item-group">
                  <div v-for="(item3, key3) in item2.items"
                       :key="key3"
                       class="buy-item">

                    <div class="buy-item-block">
                      <p class="white-text-small">
                                          <span class="yellow-text-small">
                                              {{ item3.accomodationType + " / " + item3.roomCategory + " / " + item3.adult + " / " }}
                                          </span>
                        {{ item3.pansion + (item3.pansionAdditionalInfo != null ? " / " + item3.pansionAdditionalInfo : "") }}
                        <span v-if="item3.hotelData.CriticalInfo"> / </span>
                        <span v-if="item3.hotelData.CriticalInfo" class="red-text">{{ localizeList[item3.hotelData.CriticalInfo] }}</span>
                      </p>
                      <div>
                        <div @mouseleave="hidePopover()"
                            @mouseenter="showPopover(getQuotaText(item3, 3), $event)">
                            <icon v-if="getBuyIconStatus(item3) === 'aviailable'"
                                  name="aviailable" width="16px" height="16px" />
                            <icon v-else-if="getBuyIconStatus(item3) === 'less'"
                                  name="less" width="16px" height="16px" />
                            <icon v-else-if="getBuyIconStatus(item3) === 'not-aviailable'"
                                  name="not-aviailable" width="16px" height="16px" />
                            <icon v-else
                                  name="request" width="16px" height="16px" />
                        </div>
                      </div>
                      <div :style="{'opacity': showBuyListPrice(item2.items, key3) ? 1 : 0}">
                        <p v-if="showTotalPrice" class="white-text-xsmall text-end buy-list-price">
                          {{localizeList.summaryLower}}
                        </p>
                        <p v-if="showTotalPrice" class="white-text-xsmall text-end buy-list-price">
                          {{ correctPrice(item2.price) }} {{getCurrencyDisplayBySettings(rate) }}
                        </p>
                        <p class="white-text-small text-end buy-list-price">
                          {{ correctPrice(item2.cost) }} {{getCurrencyDisplayBySettings(rate) }}
                        </p>
                      </div>

                      <!-- <p style="opacity: 0"
                        class="white-text-small text-end hidden-buy-list-price">
                        {{ correctPrice(item2.cost) }} {{getCurrencyDisplayBySettings(rate) }}
                      </p> -->

                      <div :style="{'opacity': showBuyListPrice(item2.items, key3) ? 1 : 0}"
                          class="next-angle buy-list-price-angle"></div>

                      <!-- <div style="opacity: 0"
                          class="next-angle hidden-buy-list-price-angle"></div> -->
                    </div>
                    <div v-if="showCancellationPolicy"  class="cancellation-policy-block">
                      <span v-html="getPenaltyInfo(item2.penalties, true)" style="font-size: 8pt; color: lightgrey" />
                    </div>
                    <div v-if="getWindowSettings.showQuiQuoService" class="buy-item-actions" @click.stop>
                      <div class="qq-btn-place qui-quo-place" :data-value="getQuiQuoJSON(item, item2, item3)">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
<!--            <base-button :size="getPriceSize(item.Cost)" padding="12px 8px">
              {{ localizeList.fromPrice }} {{ correctPrice(item.Cost) }} {{ getCurrencyDisplayBySettings(rate) }}
            </base-button>-->
            <p v-if="!buyListShow[key] && showTotalPrice" style="font-size: 10pt; text-align: right;">
              {{localizeList.summaryLower}} {{ correctPrice(item.Price) }} {{getCurrencyDisplayBySettings(rate) }}
            </p>
            <base-button padding="12px 8px"
                         :disabled="loaderButtonStatus[key]"
                         :size="getPriceSize(item.Cost)">
              <span v-if="!loaderButtonStatus[key]" class="buy-btn-title">
                {{ localizeList.fromPrice }} {{ correctPrice(item.Cost) }} {{ getCurrencyDisplayBySettings(rate) }}

                <svg v-if="hasHotel(item)" :class="{'rotate': buyListShow[key]}" width="9px" height="13px" fill="#727272">
                  <use xlink:href="../../../assets/images/sprite.svg#angle"></use>
                </svg>
              </span>
              <base-loader v-else width="84" size="22" weight="5"/>
            </base-button>
          </div>
        </div>
      </div>
    </div>

    <!-- Попап BuyList для отображения в карте -->
    <!-- <template v-if="listType === 'map'">
      <div v-if="buyListShow[buyListMap.key]"
            class="buy-list-map"
            :class="buyListMap.rect.arrow === 'up' ? 'buy-list-map-up' : 'buy-list-map-down'"
            :style="{ top: buyListMap.rect.top + 'px' }"
            ref="buyListMap">
        <div class="buy-item-wrap-map">
          <div v-for="(item2, key2) in buyList[buyListMap.key]"
                :key="key2"
                @click="buyTour(item2, key2)"
                class="buy-item-group-map">
            <div v-for="(item3, key3) in item2.items"
                  :key="key3"
                  class="buy-item-map">

              <div class="buy-item-block-map">
                <p class="white-text-small">
                  <span class="yellow-text-small">
                      {{ item3.accomodationType + " / " + item3.roomCategory + " / " + item3.adult + " / " }}
                  </span>
                  {{ item3.pansion + (item3.pansionAdditionalInfo != null ? " / " + item3.pansionAdditionalInfo : "") }}
                  <span v-if="item3.hotelData.CriticalInfo"> / </span>
                  <span v-if="item3.hotelData.CriticalInfo" class="red-text">{{ localizeList[item3.hotelData.CriticalInfo] }}</span>
                </p>

                <div @mouseleave="hidePopover()"
                    @mouseenter="showPopover(getQuotaText(item3, 3), $event)">
                    <icon v-if="getBuyIconStatus(item3) === 'aviailable'"
                          name="aviailable" width="16px" height="16px" />
                    <icon v-else-if="getBuyIconStatus(item3) === 'less'"
                          name="less" width="16px" height="16px" />
                    <icon v-else-if="getBuyIconStatus(item3) === 'not-aviailable'"
                          name="not-aviailable" width="16px" height="16px" />
                    <icon v-else
                          name="request" width="16px" height="16px" />
                </div>

                <p :style="{'opacity': showBuyListPrice(item2.items, key3) ? 1 : 0}"
                  class="white-text-small text-end buy-list-price-map">
                  {{ correctPrice(item2.cost) }} {{getCurrencyDisplayBySettings(rate) }}
                </p>
                <div :style="{'opacity': showBuyListPrice(item2.items, key3) ? 1 : 0}"
                    class="next-angle buy-list-price-angle"></div>
              </div>

              <div v-if="getWindowSettings.showQuiQuoService" class="buy-item-actions" @click.stop>
                <div class="qq-btn-place qui-quo-place" :data-value="getQuiQuoJSON(buyListMap.item, item2, item3)">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template> -->

  </div>
</template>

<script>
import resultSliderNew from "../resultSliderNew";
import {bus} from "../../../main";
import moment from "moment";
import CountryInfo from "./countryInfo";
import {searchResultMethods, showPenaltyAndTotalPrice} from "../../../plugins/methodsSearchResult";

export default {
  name: "cardResult",
  mixins: [showPenaltyAndTotalPrice, searchResultMethods],
  components: {
    CountryInfo,
    resultSliderNew,
  },
  props: {
    rate: {
      type: Object,
      required: true
    },
    COInfo: {
      type: Object,
      required: true
    },
    tourResultList: {
      type: Array,
      required: true
    },
    sliderDefaultImage: {
      type: Array,
      required: true
    },
    sliderDefaultImageCount: {
      type: Array,
      required: true
    },
    tourAllImages: {
      type: Array,
      required: true
    },
    buyListShow: {
      type: Array,
      default: () => []
    },
    buyList: {
      type: Array,
      required: true
    },
    listType: {
      type: String,
      required: true
    },
    buyListNotHotelKey: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      maxFeaturesHeight: 0,
      hiddenResult: false,
      collapse: false,
      loaderButtonStatus: [],
      buyListMap: {
        key: null,
        item: {},
        rect: {}
      },
      coInfo: {
        coId: 0,
        imgPath: ""
      },
      coInfoList: []
    }
  },
  computed:{
    settings() {
      const settings = this.$store.getters['getSettings'];
      return settings;
    },
    getWindowSettings(){
      return window.settings
    },
  },
  created() {
    bus.$on("hotels_collapse", (val) => {
      this.collapse = val;
      this.$store.dispatch("hotels/A_COLLAPSE", val);
    });
    bus.$on("hotels_toggle-map", (val) => {
      this.hiddenResult = val
    });
    bus.$on("changeListType-for-hotels", () => {
      this.setFeaturesMaxHeight();
    });
    window.addEventListener("scroll", this.scroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scroll);
  },
  mounted() {
    if (this.tourResultList.length) {
      this.coInfoList = [];
      this.getCOImages(this.tourResultList);
      this.setFeaturesMaxHeight()
    }
  },
  methods: {
    // showBuyListMap(e){
    //   if(this.listType === "grid") return;

    //   const pageYOffset = window.pageYOffset;
    //   const rect = e.target.getBoundingClientRect();

    //   console.log('rect', rect)
    //   const position = {
    //     top: rect.top + pageYOffset,
    //     arrow: 'down'
    //   }

    //   if(rect.top < 320){
    //     position.top = rect.top + pageYOffset - 40
    //     position.arrow = "up"
    //   } else {
    //     position.top = rect.top + pageYOffset - 420
    //     position.arrow = "down"
    //   }

    //   console.log('position', position)

    //   this.buyListMap.rect = position;
    // },
    getQuiQuoJSON(item, item2, item3) {
      const getTourDataQuiQuo = window.settings.getTourDataQuiQuo;
      const tourUrl = item.TourUrl;
      const tourName = item.Name;

      const startDate = item.StartDate.split('T')[0];
      const [year, month, day] = startDate.split('-')
      const beginDate = `${day}.${month}.${year}`

      const { adult, childs, childAges } = this.getAdultAndChildsFromHref()

      const { names, countries, city, hotelUrl } = this.getHotelQuiQuoData(item.hotels)

      const roomInfo = item3.accomodationType + " / " + item3.roomCategory + " / " + item3.adult;

      const name = getTourDataQuiQuo ? tourName : names;
      const href = getTourDataQuiQuo ? tourUrl : hotelUrl;

      let imageUrl;
      const tourKey = item.Key
      const hotelKey = item.hotels[0].Hotel.Key
      const isTourImage = this.sliderDefaultImage.find(x => x.includes(`code=${tourKey}`))
      const isHotelImage = this.sliderDefaultImage.find(x => x.includes(`code=${hotelKey}`))
      if (getTourDataQuiQuo && isTourImage) {
        imageUrl = isTourImage
      } else if (!getTourDataQuiQuo && !isHotelImage) {
        imageUrl = isTourImage
      } else {
        imageUrl = isHotelImage
      }

      const QuiQuoObject = {
        checkinDt: beginDate,
        nights: String(item.DurationInNight),
        hotelName: name,
        roomType: roomInfo,
        boardType: item3.pansion,
        price: item2.cost,
        currency: item.rate?.IsoCode || this.getCurrencyFromHref(),
        city_from: item.CityDepature.Value,
        occupancy: {
          adultsCount: parseInt(adult),
          childrenCount: childs || 0,
          childAges: childAges || 0,
        },
        region: city,
        country: countries,
        thumbnail: imageUrl || "",
        href
      }

      return JSON.stringify(QuiQuoObject)
    },
    getCurrencyFromHref(){
      let currency;
      location.href.split('&').forEach(x => {
        if (x.includes('currency')) {
          currency = x.split('=')[1]
        }
      });
      return currency
    },
    getAdultAndChildsFromHref(){
      let adult = null;
      let childs = null;
      let childAges = null;

      location.href.split('&').forEach(x => {
        if (x.includes('adultCount')) {
          adult = x.split('=')[1]
        }
        if (x.includes('childAges')) {
          childAges = x.split('=')[1]
        }
        if (x.includes('childAges')) {
          childs = x.split('=')[1].split(',').length
        }
      });

      return {
        adult,
        childs,
        childAges
      }
    },
    getHotelQuiQuoData(hotels){
      const names = hotels.map(item => item.Hotel.Value).join(", ")
      const hotelUrl = hotels[0].Http
      const countries = hotels[0].Country.Value
      const city = hotels[0].City.Value
      const rooms = hotels.map(item => {
          return item.HotelDetails.map(subitem => subitem.Room.Value).join(', ')
      }).join(', ')

      return { names, countries, city, rooms, hotelUrl }
    },
    selectHotel(item) {
      const hotelKeys = item.hotels.map(x => x.Hotel.Key);
      bus.$emit("tour_selectHotel_hotels", hotelKeys);
      bus.$emit("hotels_collapse", false);
    },
    getMainImage(key) {
      if (!this.sliderDefaultImage[key]) return "";

      return `url(${this.sliderDefaultImage[key]})`;
    },
    async setFeaturesMaxHeight() {
      this.maxFeaturesHeight = 0;

      await this.$nextTick(() => {});

      const features = document.getElementsByClassName('features');
      const featuresArray = Array.from(features);
      let maxHeight = 0;
      featuresArray.forEach(x => {
        maxHeight = x.scrollHeight > maxHeight ? x.scrollHeight : maxHeight;
      });

      this.maxFeaturesHeight = maxHeight + 'px';
      for (let i = 0; i < maxHeight; i++) {
        this.loaderButtonStatus.push(false)
      }
    },
    hoverList(key) {
      this.$emit("hoverList", key)
    },
    leaveList(key) {
      this.$emit("leaveList", key)
    },
    serviceClick(item) {
      this.$emit("serviceClick", item)
    },
    rightModalAviaFlight(item) {
      this.$emit("rightModalAviaFlight", item)
    },
    getServiceName(service) {
      let quota = this.getQuotaTextOfServices(service);
      return this.localizeList[service[0].local] + (quota ? ` (${quota.toLowerCase()})` : '')
    },
    getQuotaTextOfServices(service) {
      const quotaServices = this.$store.getters['getQuotaServices'].map(x => x.Key);
      let helper = false;
      service.forEach(x => {
        if (!quotaServices.includes(x.SvKey)) {
          helper = true
        }
      });
      if (helper) return "";

      let res = "";
      let priority = 4;
      service.forEach(x => {
        const details = x.Details || x.BusTransferDetails || x.RailwayTransferDetails;
        const quota = details[0].QuotaStatus;

        if (quota.PlacesStatus === 4 && priority >= 1) {
          res = this.localizeList.onRequest;
          priority = 1
        } else if (quota.PlacesStatus === 1 && quota.FreePlaces > 0 && priority >= 2) {
          const placesLeft = quota.FreePlaces === 1 ? 'placesLeft1' : (quota.FreePlaces < 5 ? 'placesLeft2' : 'placesLeft3');
          res = this.localizeList[placesLeft].replace("{}", quota.FreePlaces);
          priority = 2;
        } else if (quota.PlacesStatus === 1 && priority >= 3) {
            res = this.localizeList.available;
            priority = 3;
        } else if (quota.PlacesStatus === 2 && priority === 4) {
              res = this.localizeList.quotaHasNoPlaces
        }
      });

      return res
    },
    getServices(item) {
      let res = [];
      const notRouteServices = item.NotRouteServices.flat();
      const allServices = [...notRouteServices, ...item.Services];
      allServices.forEach(x => {
        if (x.SvKey !== 1 && x.SvKey !== 3 && !x.IsHooded) {
          if (x.SvKey === 2) {
            x.tourName = item.Name;
            x.typeIcon = "taxi";
            x.local = "transfer";
            x.order = 1;
          } else if (x.SvKey === 4) {
            x.typeIcon = "excursion";
            x.local = "excursionsUpper";
            x.order = 2;
          } else if (x.SvKey === 14) {
            x.tourName = item.Name;
            x.typeIcon = "bus";
            x.local = "busTransfer";
            x.order = 0;
            // } else if (x.SvKey === 6 || x.SvKey === 5) {
            //     return;
          } else if (x.SvKey === 15) {
            x.tourName = item.Name;
            x.typeIcon = "train";
            x.local = "railwayTransfer";
            x.order = 0;
          } else {
            x.typeIcon = 'network';
            x.local = "tourProgram";
            x.order = 5;
          }

          const isChecked = !x.IsNotCalculate || !x.IsDeleted;
          if (!isChecked) return;

          const index = res.map(x2 => x2.some(x3 => x3.local === x.local)).indexOf(true);
          if (index === -1) {
            res.push([x])
          } else {
            res[index].push(x)
          }
        }
      });

      const hasHotel = this.getHotelName(item);
      const hasFlight = this.hasFlight(item);

      // Проветряем если услуг больше 6 убираем экскурсию
      if (hasHotel && hasFlight && res.length > 4) {
        res = res.filter(x => x[0].SvKey !== 4);
      }

      return res
    },
    hasCoImage(id) {
      return this.coInfoList.some(x => x.coId == id);
    },
    // получаем пути картинок ЦБ
    getCOImages(tours) {
      const path = `${this.$store.getters['getApiOrigin']}${this.$store.getters['getPath']}`;

      const keys = tours.flatMap(tour =>
          tour.Services
              .filter(service => service?.SvKey === 3)
              .flatMap(service => service?.COAndSpecialsInfo || [])
              .flatMap(info => info?.AppliedCostOffersKeys || [])
              .filter(key => key != null)
      );
      // получаем пути иконок
      if (keys.length > 0) {
          this.$store.dispatch('tour/A_GET_CO_IMAGES', { Path: path, Keys: keys })
              .then(res => {
                  if (res?.data) {
                      // Обновляем список с информацией о путях иконок
                      this.coInfoList = res.data.map(item => ({
                          coId: item.Key,
                          imgPath: item.Value
                      }));
                  }
              })
              .catch(error => {
                  console.error('Ошибка при получении путей изображений:', error);
              });
        }
    },

    getHotelCOAndSpecialInfo(item, key) {
      const res = [];
      const hotel = item.Services.filter(x => x.SvKey === 3);
      const index = key;
      const path = `${this.$store.getters['getApiOrigin']}${this.$store.getters['getPath']}`;
      const transfers = item.Services.filter(x => x.SvKey === 2);

      if (!hotel.length) return res;

      let COKeys = hotel[index].COAndSpecialsInfo.AppliedCostOffersKeys;
      if (this.COInfo?.costOffersImageInformation) {
        this.COInfo.costOffersImageInformation.filter(x => {
          if (COKeys && COKeys.includes(x.IdCostOffer)) {
            res.push({
              id: x.IdCostOffer,
              type: 1,
              title: x.InfoText,
              src: `${path}/GetImage/GetCostOfferFile?&id=${x.IdCostOffer}&width=50&height=50&text=${!!x.InfoText}`
            })
          }
        });
      }

      let specialInfo = hotel[index].COAndSpecialsInfo.AppliedSpeciasInfo?.AppliedSpeciasInfo;
      if (specialInfo) {
        specialInfo.forEach(x => {
          const title = this.$store.getters['hotels/getSpecialText'](x, this.localizeList);
          const src = `${path}/GetImage/GetSpecialsImage?specialType=${x.SpecialType}&width=100&height=100`;
          const isInclude = res.map(x2 => `${x2.title}${x2.src}`).includes(`${title}${src}`);
          if (isInclude) return;

          res.push({
            id: x.IdCostOffer,
            type: 2,
            title,
            src
          })
        });
      }

    if (transfers.length) {
        transfers.forEach(x => {
            let spInfo = x.COAndSpecialsInfo.AppliedSpeciasInfo?.AppliedSpeciasInfo;
            if (spInfo) {
                spInfo.forEach(si => {
                    const title = this.$store.getters['hotels/getSpecialText'](si, this.localizeList);
                    const src = `${path}/GetImage/GetSpecialsImage?specialType=${si.SpecialType}&width=100&height=100`;
                    const isInclude = res.map(x2 => `${x2.title}${x2.src}`).includes(`${title}${src}`);
                    if (isInclude) return;

                    res.push({
                        id: x.IdCostOffer,
                        type: 2,
                        title,
                        src
                    })
                });
            }
        });
    }

      return res;
    },
    getQuotaText(item, svKey) {
      const quotaServices = this.$store.getters['getQuotaServices'].map(x => x.Key);
      if (!quotaServices.includes(svKey)) {
        return ""
      }

      const quota = item.quotaStatus || item.QuotaStatus;
      let res = null;
      if (quota.PlacesStatus === 4) {
        res = this.localizeList.onRequest
      } else if (quota.PlacesStatus === 1 && quota.FreePlaces > 0) {
        const placesLeft = quota.FreePlaces === 1 ? 'placesLeft1' : (quota.FreePlaces < 5 ? 'placesLeft2' : 'placesLeft3');
        res = this.localizeList[placesLeft].replace("{}", quota.FreePlaces);
      } else if (quota.PlacesStatus === 2) {
          res = this.localizeList.quotaHasNoPlaces
      } else {
        res = this.localizeList.available
      }
      return res
    },
    buyTour(item, key) {
      this.$emit("buyTour", [item, key])
    },
    getServiceQuotaStatus(item, svKey = null) {
      let res = '#BEBEBE';
      let priority = 4;

        const quotaServices = this.$store.getters['getQuotaServices'].map(x => x.Key);

      const data = svKey !== null ? item.Services.filter(x => x.SvKey === svKey) : item;
      data.forEach(x => {
        if (!quotaServices.includes(x.SvKey)) {
          priority = 0
        }
      });

      data.forEach(x => {
        const detail = x.FlightDetails ||
          x.HotelDetails ||
          x.BusTransferDetails ||
          x.RailwayTransferDetails ||
          x.Details;

        if (!detail) {
          priority = 0
        }

        if (detail[0] != 'undefined' && detail[0] != null) {

              const quota = detail[0].QuotaStatus;
              if (quota.PlacesStatus === 4 && priority >= 1) {
                  res = "var(--yellow-color)";
                  priority = 1
              } else if (quota.PlacesStatus === 1 && quota.FreePlaces > 0 && priority >= 2) {
                  res = "var(--primary-color)";
                  priority = 2;
              } else if (quota.PlacesStatus === 1 && priority >= 3) {
                  res = "#4ACA7F";
                  priority = 3;
              } else if (quota.PlacesStatus === 2 && priority === 4) {
                  res = "#ff0000"
              }
          }
      });

      return res
    },
    toggleBuyList(key, item, onlyList = false) {
      this.buyListMap.key = key;
      this.buyListMap.item = item;
      this.loaderButtonStatus[key] = true
      this.$emit("toggleBuyList", [key, item, onlyList])
    },
    rightModalHotelInfo(item, key1, key2 = 0) {
        if (key2 === null) {
          let searchIndexHotelNoCoord = item.hotels.findIndex((x) => x.Latitude && x.Longitude)
          key2 = searchIndexHotelNoCoord !== -1 ? searchIndexHotelNoCoord : 0;
        }
        let viewRemoteHotels = this.settings.ViewRemoteHotels;
        if (viewRemoteHotels) {
          let hotels = item.Services.filter(x => x.SvKey === 3);
          if (hotels.length > 0) {
              if (hotels[key2].Http !== null && hotels[key2].Http !== "") {
                  window.open(hotels[key2].Http, '_blank');
              } else {
                  this.$emit("rightModalHotelInfo", [item, key1, key2]);
              }
          } else {
              this.$emit("rightModalHotelInfo", [item, key1, key2])
          }
      } else {
          this.$emit("rightModalHotelInfo", [item, key1, key2])
      }
    },
    getFlightOrHotelQuotaText(item, svKey) {
      const quotaServices = this.$store.getters['getQuotaServices'].map(x => x.Key);
      if (!quotaServices.includes(svKey)) {
        return ""
      }
      let priority = 4;
      let res = "";

      const services = item.Services.filter(x => x.SvKey === svKey);

      services.forEach(x => {
        const details = svKey === 1 ? x.FlightDetails[0] : x.HotelDetails[0];
        const quota = details.quotaStatus || details.QuotaStatus;

        res = svKey === 1 ? this.localizeList.flight : this.localizeList.accommodation;
        if (quota.PlacesStatus === 4 && priority >= 1) {
          res += ` (${this.localizeList.onRequest.toLowerCase()})`;
          priority = 1
        } else if (quota.PlacesStatus === 1 && quota.FreePlaces > 0 && priority >= 2) {
          const placesLeft = quota.FreePlaces === 1 ? 'placesLeft1' : (quota.FreePlaces < 5 ? 'placesLeft2' : 'placesLeft3');
          res += ` (${this.localizeList[placesLeft].replace("{}", quota.FreePlaces).toLowerCase()})`;
          priority = 2
        } else if (quota.PlacesStatus === 1 && priority >= 3) {
            res += ` (${this.localizeList.available.toLowerCase()})`;
            priority = 3;
        } else if (quota.PlacesStatus === 2 && priority === 4) {
            res += ` (${this.localizeList.quotaHasNoPlaces.toLowerCase()})`;
        }
      });

      return res
    },
    rightModalHotelOrTourInfo(item, key, e) {
      let doNotShowEmptyHotelCards = this.settings.DoNotShowEmptyHotelCards;
      if(doNotShowEmptyHotelCards){
        let hotels = item.Services.filter(x => x.SvKey === 3);
        if(hotels.length > 0){
          if(!hotels[0].HasImages){
            return;
          }
        }
      }
      const isTour = this.getMainImage(key).includes("tours");
      if (isTour) {
          this.rightModalBooking(item.BookingConditions, item, key)
      } else {
          let viewRemoteHotels = this.settings.ViewRemoteHotels;
          if (viewRemoteHotels) {
              let hotels = item.Services.filter(x => x.SvKey === 3 && x.Http !== null && x.Http !== "");
              if (hotels.length > 0) {
                  window.open(hotels[0].Http, '_blank');
              } else {
                  this.$emit("rightModalHotelOrTourInfo", [item, key, e]);
              }
          } else {
              this.$emit("rightModalHotelOrTourInfo", [item, key, e]);
          }
      }
      //this.$emit("rightModalHotelOrTourInfo", [item, key, e])
    },
    rightModalBooking(html, item, key) {
      this.$emit("rightModalBooking", [html, item, key])
    },
    isActiveHotelName(item, key2){
        let doNotShowEmptyHotelCards = this.settings.DoNotShowEmptyHotelCards;
        if (doNotShowEmptyHotelCards) {
            let hotels = item.Services.filter(x => x.SvKey === 3);
            if (hotels.length > 0) {
                let viewRemoteHotels = this.settings.ViewRemoteHotels;
                if (viewRemoteHotels) {
                    return hotels[0].HasImages || (hotels[0].Http !== null && hotels[0].Http !== "");
                }
                return hotels[key2].HasImages;
            }
        }
        return true;
    },
    hasTourImages(url) {
      return url?.includes("tours")
    },
    showHotelList(item, key) {
      if (item.hotels.length > 1) {
        item.showHotelsList = !item.showHotelsList
      } else {
        this.rightModalHotelInfo(item, key)
      }
    },
    cardTitle(item) {
      // const el = this.$refs.resultHeadlineTextGrid?.[key];
      // if (el) {
      //     const wordArray = el.innerHTML.split(' ');
      //     while(el.scrollHeight > el.offsetHeight) {
      //         wordArray.pop();
      //         el.innerHTML = wordArray.join(' ') + '...';
      //     }
      // }

      // return (this.getHotelCity(item) ? this.getHotelCity(item) + ". " : "") + item.Name
      return item.Name
    },
    smallImgToMedium(url) {
      if (!url) return;

      return url.replace('small160x90', 'medium')
    },
    imgFilterByTourKey(images, item) {
      let path = this.$store.getters['getPath'];

      return images
        .filter(x => x.TourKey === item.Key)
        .map(x => {
          return `${this.$store.getters['getApiOrigin']}${path}/Image/GetImage?code=${x.TourKey ? x.TourKey : 639}&type=medium&name=${x.Name}&imageType=tours`;
        })
    },
    hasHotel(item) {
      return item.Services.some(x => x.SvKey === 3);
    },
    getHotelName(item) {
      let hotel = item.Services.filter(x => x.SvKey === 3);
      const index = 0;

      if (!hotel.length) return "";

      return hotel[index].Hotel.Value;
    },
    getHotelHref(item) {
      return item.Services.find(x => x.SvKey === 3)?.Http || ''
    },
    getSubHotelStars(value) {
      return  this.getStars(value) ? this.getStars(value) : value;
    },
    getHotelStars(item) {
      let res = 0;
      let hotel = item.Services.filter(x => x.SvKey === 3);
      const index = 0;

      if (!hotel.length) return "";

      res = this.getStars(hotel[index].Stars.Value) ? this.getStars(hotel[index].Stars.Value) : hotel[index].Stars.Value;

      return res;
    },
    getStars(val) {
      if (!val) {
        return val
      }
      let res = 0;
      let stars = parseInt(val[0]);
      if (typeof stars === "number" && !isNaN(stars)) {
        res = stars
      }
      return res
    },
    getNoHotelText(item) {
      let cityTo = item.Services.find(x => x.CityTo);
      cityTo = cityTo ? cityTo.CityTo.Value : item.CityDepature.Value;
      return cityTo + ", " + this.getTourDuration(item, true)
    },
    getTourDuration(item, checkNight = false) {
      const duration = item.Duration + " " + this.getDayLocal(item.Duration, 'day');
      const durationInNight = item.DurationInNight + " " + this.getDayLocal(item.DurationInNight, 'night');

      if (checkNight && !item.DurationInNight) {
        return duration;
      }

      return `${duration} (${durationInNight}`;
    },
    getTravelDuration(item) {
      const durationTravel = (item.Duration || 0)-(item.DurationInNight || 0)-1;
      let durationTravelText = durationTravel > 0 ? ` +${durationTravel}` : '';

      return `${durationTravelText}`;
    },
    getAdditionalDataTitle(item) {
      const durationTotal = item.Duration - 1;
      const durationTravel = durationTotal - item.DurationInNight;

      const firstTitleText = this.localizeList['daysNightsTourDuration'];
      const titleText = this.localizeList['daysNightsHotelAndTravel'];
      let itemHotel = '';
      let itemTravel = '';
      let itemDuration = '';
      itemHotel = this.getDayLocal(item.DurationInNight, 'night');
      itemTravel = this.getDayLocal(durationTravel, 'night');
      itemDuration = this.getDayLocal(item.Duration, 'day');

      let newStr = '';
      if (durationTravel <= 0) {
        newStr = `${firstTitleText.replace('{0}', item.Duration).replace('{1}', itemDuration).replace('{2}', item.DurationInNight).replace('{3}', itemHotel)}`
      } else {
        newStr = `${firstTitleText.replace('{0}', item.Duration).replace('{1}', itemDuration).replace('{2}', item.DurationInNight).replace('{3}', itemHotel)}
                  ${titleText.replace('{0}', item.DurationInNight).replace('{1}', itemHotel).replace('{2}', durationTravel).replace('{3}', itemTravel)}`;
      }

      return newStr
    },
    getDayLocal(day, type) {
      if (day === 1) {
        return this.localizeList[type]
      } else if (day < 5 && day > 1) {
        return this.localizeList[type+"2"]
      } else {
        return this.localizeList[type+"s"]
      }
    },
    getHotelType(item, key) {
      const hotel = item.Services.filter(x => x.SvKey === 3);
      if (!hotel.length) return "";

      return hotel[key].HotelTypes;
    },
    getHotelTypeIcon(key) {
      let path = this.$store.getters['getPath'];
      return `${this.$store.getters['getApiOrigin']}${path}/GetImage/GetImage?type=hotelType&id=${key}&width=20&height=20`
    },
    showPopover(text, e, nowrap = true) {
      if (!text || text.length == 0) return;

      let rect = e.target.getBoundingClientRect();
      let res = {
        x: rect.left + (rect.width / 2),
        y: rect.top,
        text: text?.replaceAll('\n', '<br>'),
        height: rect.height,
        nowrap
      };
      this.$store.dispatch("A_SHOW_POPOVER", res)
    },
    hasFlight(item) {
      return item.Services.map(x => x.SvKey).includes(1)
    },
    shortDate(date) {
      let res = date.split("T")[0].split("-").reverse().join(".");
      res = moment(date).format("DD MMM");
      return res
    },
    correctDurationNight(n) {
      if (n <= 1)
        return n +" "+ this.localizeList.night;
      else if (n < 5)
        return  n +" "+ this.localizeList.night2;
      else
        return  n +" "+ this.localizeList.nights;
    },
    showServiceCount(service) {
      if (service[0].SvKey === 2 || service[0].SvKey === 14 || service[0].SvKey === 15) {
        return false
      }
      return service.length > 1
    },
    getTourDate(item) {
      if (this.collapse) {
        return this.localizeList.moreDate
      }

      const startDate = this.correctDate(item.StartDate);
      let endDate = null;
      if (item.Services.length) {
        endDate = this.correctDate(item.Services[item.Services.length-1].EndDateTime);
      }
      return `${startDate}` + (endDate ? ` – ${endDate}` : '')
    },
    getHotelCityAndResort(item, key) {
      const hotels = item.Services.filter(x => x.SvKey === 3);
      if (!hotels.length) return "";

      const checkCityWithResort = (city, resort) => {
      const equal = city?.toLowerCase() === resort?.toLowerCase();
        if (city && resort && !equal) {
          return city + "/" + resort;
        } else {
          return city;
        }
      };

      return checkCityWithResort(hotels[key]?.City.Value, hotels[key]?.Resort.Value);
    },
    getTourTourist() {
      let adult = null;
      let child = null;
      location.href.split('&').forEach(x => {
        if (x.includes('adultCount')) {
          adult = x.split('=')[1]
        }
        if (x.includes('childAges')) {
          child = x.split('=')[1].split(',').length
        }
      });
      adult = adult + " " + this.getTouristLocal(+adult, 'adult').toLowerCase();
      if (!child) return adult;

      child = child + " " + this.getTouristLocal(child, 'child').toLowerCase();
      return `${adult}, ${child}`
    },
    getTouristLocal(count, type) {
      if (count === 1) {
        return this.localizeList[type]
      } else if (type === 'child') {
        return this.localizeList.children
      } else {
        return this.localizeList[type+"s2"]
      }
    },
    getPriceSize(cost) {
      return cost > 999999 ? 13 : 16
    },
    getCurrencyDisplayBySettings(rate){
      return this.$store.getters['getCurrencyDisplayBySettings'](rate);
    },
    getBuyIconStatus(item) {
      const quota = item.quotaStatus || item.QuotaStatus;
      if (quota.PlacesStatus === 1 && quota.FreePlaces === 0) {
        return "aviailable"
      } else if (quota.PlacesStatus === 1 && quota.FreePlaces > 0) {
        return "less"
      } else if (quota.PlacesStatus === 4) {
        return "request"
      } else if (quota.PlacesStatus === 2) {
          return "not-aviailable"
      }
    },
    showBuyListPrice(items, key) {
      return Math.floor(items.length / 2) === key
    },
    stop(e) {
      e.stopPropagation();
      e.preventDefault();
    },
  },
  watch: {
    tourResultList: {
      deep: true,
      handler() {
        this.coInfoList = [];
        this.getCOImages(this.tourResultList);
        this.setFeaturesMaxHeight();
      }
    },
    buyListShow: {
      deep: true,
      handler(val) {
        const getActiveIndex = val.indexOf(true)
        this.loaderButtonStatus[getActiveIndex] = false
      }
    },
    buyListNotHotelKey(val) {
      if (val === null) return
      this.loaderButtonStatus[val] = false
      this.$emit('resetBuyListNotHotelKey') // Сбрасываем buyListNotHotelKey, чтобы при повторном клике наблюдатель отрабатывал
    }
  }
}
</script>

<style scoped>
.qui-quo-place {
  background: #ffffffd4;
  padding: 2px 4px 6px 6px;
  border-radius: 10px;
}

.grid-tour-result-list.collapse {
  /*transform: translateX(100%);*/
  margin-right: -300px;
  width: 0;
}
.grid-tour-result-list.collapse .card-wrap {
  opacity: 0;
}
.grid-tour-result-list .card-wrap {
  transition: all .2s;
}
.grid-tour-result-list .country-info {
  width: 100%;
  grid-column: 1 / 4;
  margin-bottom: 3px;
}

.grid-tour-result-list {
  display: grid;
  grid-template-columns: repeat(3, 300px);
  grid-gap: 15px;
  justify-content: center;
  transition: all .2s;
  /*overflow: hidden;*/
}
.grid-tour-result-list.map-mode {
  grid-template-columns: 300px;
  padding-bottom: 40px;
}
.list-group.map-mode .grid-tour-result-list {
  width: auto;
}
.grid-tour-result-list .card {
  background: var(--white-color);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  position: relative;
  z-index: 2;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.grid-tour-result-list .card-wrap {
  position: relative;
}
.grid-tour-result-list .card-wrap .layer {
  display: none;
}
.grid-tour-result-list .card-wrap.collapse .layer {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  background-color: var(--white-color);
}
.grid-tour-result-list .card-wrap.collapse .layer-1 {
  /*background: var(--lighten-4-color);*/
  transform: translate(3px, 2px);
  z-index: 1;
}
.grid-tour-result-list .card-wrap.collapse .layer-2 {
  /*background: var(--lighten-7-color);*/
  transform: translate(6px, 4px);
  z-index: 0;
}

.grid-tour-result-list .card .card-header {
  /* height: 60px; */
  padding: 6px 10px;
  position: relative;
}
.grid-tour-result-list.map-mode .card .card-header {
  height: unset;
  padding-bottom: 8px;
  margin-bottom: 6px;
  border-bottom: 1px dashed var(--lighten-4-color);
}
.grid-tour-result-list .card .card-header .program-name {
  font-size: 13px;
  line-height: 16px;
  color: var(--primary-color);
}
.grid-tour-result-list .card .card-header .program-name.link {
  text-decoration: underline;
  cursor: pointer;
}
.grid-tour-result-list .card .more-hotels {
  font-size: 12px;
  line-height: 14px;
  text-decoration-line: underline;
  color: var(--primary-color);
  cursor: pointer;
}

.grid-tour-result-list .card-header svg {
  min-width: 18px;
}

.grid-tour-result-list .card .card-body {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.grid-tour-result-list .card .card-body .slider {
  height: 157px;
  background: #eee;
}

.grid-tour-result-list .card .card-body .rows-container {
    flex: 1 0 auto
}

.grid-tour-result-list .card .card-body .date-info {
  font-size: 11px;
  line-height: 13px;
  color: #727272;
}

.grid-tour-result-list .card .card-body .hotel-name {
  display: flex;
  margin: 6px 10px 0px;
  min-height: 19px;
}

.grid-tour-result-list .card .card-body .city-resort-info-wrap {
    overflow: hidden;
    margin: 0px 10px;
}

.grid-tour-result-list .card .card-body .city-resort-info-text {
    font-weight: 500;
    font-size: 11px;
    line-height: 16px;
    color: var(--lighten-5-color);
}

.grid-tour-result-list.map-mode .card .card-body .hotel-name {
  margin: 0 10px;
}
.grid-tour-result-list .card .card-body .hotel-name a,
.grid-tour-result-list .card .card-body .hotel-name span {
  font-weight: bold;
  font-size: 15px;
  line-height: 18px;
  color: var(--primary-color);
}

.grid-tour-result-list .card .card-body .no-hotel-text {
  margin: 12px 12px 4px;
  font-weight: 500;
  font-size: 14px;
  line-height: 19px;
  color: #929292;
}

.grid-tour-result-list .card .card-body .hotel-stars {
  display: flex;
  margin-left: 3px;
}

.grid-tour-result-list .card .card-body .location {
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  color: #727272;
  margin: 0 10px 6px;
}

.grid-tour-result-list .card .card-body .features {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin: 0 10px 6px;
  min-height: 20px;
}

.grid-tour-result-list .card .card-body .services {
  display: flex;
  align-items: center;
  padding: 6px 10px;
  border-top: 1px dashed #aaa;
  border-bottom: 1px dashed #aaa;
}
.grid-tour-result-list .card .card-body .services .services-list {
  display: flex;
}
.grid-tour-result-list /deep/ .base-button,
.grid-tour-result-list .card .card-body .services .services-list /deep/ .hover-effect {
  cursor: default;
}
.grid-tour-result-list .card .card-body .services .services-list .pointer /deep/ .hover-effect {
  cursor: pointer;
}
.grid-tour-result-list /deep/ .base-button:hover .hover-effect,
.grid-tour-result-list .card .card-body .services /deep/ .hover-effect:hover {
  opacity: 0;
}
.grid-tour-result-list .card .card-body .services .services-list .service {
  margin-left: 16px;
}
.grid-tour-result-list .card .card-body .services .services-list .service.none-left {
  margin-left: 0;
}
/* .popover-link.service {
  padding-top: 6px;
} */
.grid-tour-result-list .card .card-body .services .hotel-btn-wrap {
  margin-left: 16px;
}
.grid-tour-result-list .card .card-body .services .hotel-btn-wrap.no-flight {
  margin-left: 0;
}
.grid-tour-result-list .count {
  position: absolute;
  font-size: 10px;
  top: -11px;
  /*top: -12px;*/
  left: 50%;
  transform: translateX(-50%);
  /*font-size: 12px;*/
  text-align: center;
  font-weight: bold;
  color: var(--lighten-5-color);
}
.grid-tour-result-list .card .card-body .features .popover-link {
  height: 16px;
  margin-top: 6px;
  cursor: pointer;
}

.grid-tour-result-list .card .card-body .features .popover-link:not(:last-child) {
  margin-right: 14px;
}

.grid-tour-result-list .card .card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 10px;
  column-gap: 12px;
}

.grid-tour-result-list .buy-list {
  position: absolute;
  bottom: 80px;
  right: 10px;
  left: 10px;
  background: var(--dark-1-color);
  border-radius: 6px;
  padding: 6px 0 33px;
  z-index: 10;
  max-height: 300px;
}
.grid-tour-result-list .buy-list-map {
  position: absolute;
  right: 10px;
  left: 10px;
  background: var(--dark-1-color);
  border-radius: 6px;
  padding: 6px 0 33px;
  z-index: 10;
  max-height: 300px;
}

.grid-tour-result-list .buy-list-qui-quo {
  position: absolute;
  bottom: -100%;
  right: 105%;
  left: -100%;
  background: var(--dark-1-color);
  border-radius: 6px;
  padding: 6px 0 33px;
  z-index: 10;
}

.grid-tour-result-list .buy-item-wrap {
  max-height: 300px;
  overflow: auto;
}

.grid-tour-result-list .buy-item-wrap-first {
  max-height: 130px;
  overflow: auto;
}

.grid-tour-result-list .buy-item-wrap-map {
  max-height: 300px;
  overflow: auto;
}

.grid-tour-result-list .buy-item-wrap-qui-quo {
  max-height: 130px;
  overflow: auto;
}

.grid-tour-result-list .buy-list::after {
  content: "";
  position: absolute;
  bottom: -10px;
  right: 40px;
  border-top: 10px solid var(--dark-1-color);
  border-right: 10px solid transparent;
  border-left: 10px solid transparent;
}

/* ARROW */
.grid-tour-result-list .buy-list-map-down::after {
  content: "";
  position: absolute;
  bottom: -10px;
  right: 40px;
  border-top: 10px solid var(--dark-1-color);
  border-right: 10px solid transparent;
  border-left: 10px solid transparent;
}

.grid-tour-result-list .buy-list-map-up::after {
  content: "";
  position: absolute;
  top: -10px;
  right: 40px;
  border-bottom: 10px solid var(--dark-1-color);
  border-right: 10px solid transparent;
  border-left: 10px solid transparent;
}

.grid-tour-result-list .buy-item-group {
  border-bottom: 1px dashed rgba(255, 255, 255, 0.1);
  position: relative;
}
.grid-tour-result-list .buy-item-group:last-child {
  border-bottom: none;
}
.grid-tour-result-list .buy-item-group:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
.grid-tour-result-list .buy-item-group:hover .next-angle {
  border-top: 2px solid var(--white-color);
  border-right: 2px solid var(--white-color);
}

.grid-tour-result-list .buy-item-group-map {
  border-bottom: 1px dashed rgba(255, 255, 255, 0.1);
  position: relative;
}
.grid-tour-result-list .buy-item-group-map:last-child {
  border-bottom: none;
}
.grid-tour-result-list .buy-item-group-map:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
.grid-tour-result-list .buy-item-group-map:hover .next-angle {
  border-top: 2px solid var(--white-color);
  border-right: 2px solid var(--white-color);
}

.grid-tour-result-list .card .card-footer .buy-list-price-angle,
.grid-tour-result-list .card .card-footer .buy-list-price {
  /* position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 30px; */
}
.grid-tour-result-list .buy-list-price-angle {
  right: 10px;
  top: calc(50% - 6px);
}

/* .grid-tour-result-list .card .card-footer .buy-list .buy-item {
  padding: 12px;
  display: grid;
  grid-template-columns: 1fr auto minmax(40px, auto) auto;
  grid-gap: 12px;
  align-items: center;
  cursor: pointer;
  transition: all .2s
} */

.grid-tour-result-list .buy-item-block {
  padding: 12px;
  display: grid;
  grid-template-columns: 1fr auto minmax(40px, auto) auto;
  grid-gap: 12px;
  align-items: center;
  cursor: pointer;
  transition: all .2s
}

.grid-tour-result-list .buy-item-block-map {
  padding: 12px;
  display: grid;
  grid-template-columns: 1fr auto minmax(40px, auto) auto;
  grid-gap: 12px;
  align-items: center;
  cursor: pointer;
  transition: all .2s
}

.grid-tour-result-list .buy-item-actions {
  display: flex;
  justify-content: flex-end;
  padding: 0 20px 12px 12px;
}

.grid-tour-result-list .buy-item-map.disabled {
  filter: brightness(0.5);
  cursor: default;
  background-color: transparent;
}

.grid-tour-result-list .buy-item.disabled {
  filter: brightness(0.5);
  cursor: default;
  background-color: transparent;
}

.grid-tour-result-list .buy-item-map .next-angle {
  width: 9px;
  height: 9px;
  border-top: 2px solid #aeaeae;
  border-right: 2px solid #aeaeae;
  transform: rotate(45deg);
}

.grid-tour-result-list .buy-item .next-angle {
  width: 9px;
  height: 9px;
  border-top: 2px solid #aeaeae;
  border-right: 2px solid #aeaeae;
  transform: rotate(45deg);
}

.grid-tour-result-list .buy-item-map.disabled {
  filter: brightness(0.5);
  cursor: default;
  background-color: transparent;
}

.grid-tour-result-list .buy-item.disabled {
  filter: brightness(0.5);
  cursor: default;
  background-color: transparent;
}

.grid-tour-result-list .buy-item-map .next-angle {
  width: 9px;
  height: 9px;
  border-top: 2px solid #aeaeae;
  border-right: 2px solid #aeaeae;
  transform: rotate(45deg);
}

.grid-tour-result-list .buy-item .next-angle {
  width: 9px;
  height: 9px;
  border-top: 2px solid #aeaeae;
  border-right: 2px solid #aeaeae;
  transform: rotate(45deg);
}

.grid-tour-result-list .buy-list-map.disabled.buy-item-map:hover .next-angle {
  border-top: 2px solid #aeaeae;
  border-right: 2px solid #aeaeae;
}

.grid-tour-result-list .buy-list-map.disabled.buy-item:hover .next-angle {
  border-top: 2px solid #aeaeae;
  border-right: 2px solid #aeaeae;
}

.hotels-result-content a {
  text-decoration: none;
}

.quota-line {
  position: absolute;
  bottom: 0;
  width: 25px;
  left: 2px;
  height: 0.1em;
}

.map-mode .additional-info {
  display: flex;
  align-items: center;
}

.map-mode .additional-info .img {
  width: 44px;
  height: 44px;
  border-radius: 4px;
  background-position: center;
  background-size: cover;
  background-color: #eee;
  cursor: pointer;
}

.hotels-result-content .hotel-list {
  position: absolute;
  bottom: 130px;
  right: 10px;
  left: 48px;
  background: var(--dark-1-color);
  border-radius: 6px;
  padding: 6px 0 33px;
  z-index: 10;
}
.hotels-result-content .map-mode .hotel-list {
  bottom: 66px;
  left: 10px;
}
.hotels-result-content .hotel-list.no-flight {
  left: 10px;
}

.hotels-result-content .hotel-list::after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 16px;
  border-top: 10px solid var(--dark-1-color);
  border-right: 10px solid transparent;
  border-left: 10px solid transparent;
}
.hotels-result-content .map-mode .hotel-list::after {
  left: 112px;
}
.hotels-result-content .map-mode .no-flight.hotel-list::after {
  left: 66px;
}

.hotels-result-content .hotel-list .hotel-item {
  padding: 12px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  border-bottom: 1px dashed rgba(255, 255, 255, 0.1);
  cursor: pointer;
  transition: all .2s;
  font-size: 13px;
  line-height: 18px;
  color: var(--white-color);
}
.hotels-result-content .hotel-list .hotel-item:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.row-tour-result-list .hotel-list {
  bottom: 55px;
  left: unset;
  right: -8px;
  z-index: 100;
}

.row-tour-result-list .hotel-list::after {
  left: unset;
  right: 20px;
}

.vertical-filters .grid-tour-result-list {
  grid-template-columns: repeat(3, 300px);
}
.vertical-filters .grid-tour-result-list.map-mode {
  grid-template-columns: repeat(1, 300px);
}
.vertical-filters .grid-tour-result-list .country-info {
  grid-column: 1 / 4;
}

.grid-tour-result-list.map-mode {
  position: relative;
}

.cancellation-policy-block {
  text-align: right;
  margin-top: -13px;
  padding-bottom: 10px;
  cursor: pointer;
  padding: 0px 30px 5px 5px;
  line-height: 13px
}

.grid-tour-result-list .card-header svg {
  min-width: 18px;
}

.grid-tour-result-list .buy-btn-wrap svg {
  transform: rotate(-90deg);
  fill: var(--white-color);
  opacity: .7;
  margin: 2px 0 0 10px;
  transition: all .2s;
}

.grid-tour-result-list .buy-btn-wrap svg.rotate {
  transform: rotate(90deg);
}

.grid-tour-result-list .buy-btn-wrap .buy-btn-title {
  display: flex;
  align-items: center;
  white-space: nowrap;
}

@media (min-width: 1440px) {
  .grid-tour-result-list {
    grid-template-columns: repeat(4, 300px);
  }
  .grid-tour-result-list .country-info {
    grid-column: 1 / 5;
  }
}
@media (min-width: 1600px) {
  .grid-tour-result-list.map-mode {
    grid-template-columns: repeat(2, 300px);
  }
}
@media (min-width: 1920px) {
  .vertical-filters .grid-tour-result-list {
    grid-template-columns: repeat(4, 300px);
  }
  .vertical-filters .grid-tour-result-list .country-info {
    grid-column: 1 / 5;
  }
  .grid-tour-result-list {
    grid-template-columns: repeat(5, 300px);
  }
  .grid-tour-result-list .country-info {
    grid-column: 1 / 6;
  }
}
</style>